/** =========================================================
 * Module: nav-search.js
 * Services to share navbar search functions
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.navsearch')
    .service('NavSearch', NavSearch);

  function NavSearch() {
    this.toggle = toggle;
    this.isOpen = isOpen;
    this.dismiss = dismiss;

    // //////////////

    var navbarFormSelector = 'form.navbar-form';

    function toggle() {
      var navbarForm = $(navbarFormSelector);

      navbarForm.toggleClass('open');

      var isOpen2 = navbarForm.hasClass('open');

      navbarForm.find('input')[isOpen2 ? 'focus' : 'blur']();
    }

    function isOpen() {
      var navbarForm = $(navbarFormSelector);

      return navbarForm.hasClass('open');
    }

    function dismiss() {
      $(navbarFormSelector)
        .removeClass('open') // Close control
        .find('input[type="text"]').blur() // remove focus
      // .val('') // Empty input
      ;
    }
  }
})();
